import { Header } from '@cloudscape-design/components';
import { ScrollPosition } from 'react-lazy-load-image-component';

import { EscapeRoomSessionEvent } from '../rooms/room/types';
import { EscapeChatTurn } from '../rooms/room/turn';
import { RoomActions } from '../rooms/room/actions';
import { RoomLink } from '../rooms/room/link';
import { parseCaption } from '../common/caption';

import { EscapeEvent } from './event';

export type RoomEscapedProps = {
  event: EscapeRoomSessionEvent;
  hideUsers?: boolean;
  insideContainer?: boolean;
  scrollPosition?: ScrollPosition;
};

export function RoomEscaped(props: RoomEscapedProps) {
  const event = props.event;
  const roomId = event.session_uuid;

  const roomContent = (
    <EscapeChatTurn
      header={
        <Header
          actions={
            <RoomActions event={event} roomId={roomId} scrollPosition={props.scrollPosition} />
          }
          variant="h3"
        >
          <RoomLink roomId={roomId} title={event.title} />
        </Header>
      }
      index={0}
      insideContainer={props.insideContainer}
      message={{
        role: 'assistant',
        content: event.text,
        image_url: event.image_url,
        caption: parseCaption(event.caption),
        timestamp: event.text_timestamp,
      }}
      roomId={roomId}
      scrollPosition={props.scrollPosition}
      compact
    />
  );

  if (props.hideUsers) {
    return roomContent;
  }

  return (
    <EscapeEvent event={event} title="Escaped!">
      {roomContent}
    </EscapeEvent>
  );
}
